
/*!
 * Copyright (c) 2018-present Cyclope.ai
 * LICENSE file is in the root directory of this source tree.
 * */


import * as Utils from '@Cyclope-Utils/index';
import {ParametersDisplayUpdatedActionFail, ParametersDisplayUpdatedActionInProgress, ParametersDisplayUpdatedActionSuccess} from '@tunnel-store/index';
import {Dispatch} from 'redux';


/**
 * @function ParametersDisplayUpdatedActionCreator
 * @param { any } value
 * @param { any } param
 * @return {Promise<any>}  Promise
 */
export function ParametersDisplayUpdatedActionCreator(value: any, param: any): (
    dispatch: Dispatch<any>, {}) => Promise<any> {
  return async (dispatch: Dispatch<any>) => {
    dispatch(ParametersDisplayUpdatedActionInProgress());

    Utils
        .updateRuleValue(value, 1)
        // .then(res => res.json())
        .then((data: any) => {
          if (!data.error) {
            Utils.updateRuleValue(param, 2)
                .then(response => response.json())
                .then((update: any) => {
                  return !update.error &&
                      dispatch(ParametersDisplayUpdatedActionSuccess(update));
                })
                .catch(
                    (error: any) =>
                        dispatch(ParametersDisplayUpdatedActionFail(error)))

          } else {
            dispatch(ParametersDisplayUpdatedActionFail(data.error))
          }
          return data
        })
        .catch(
            (error: any) => dispatch(ParametersDisplayUpdatedActionFail(error)))
  }
}



// WEBPACK FOOTER //
// ./src/apps/tunnel/store/actionsCreator/supervision/display/update/index.ts